import type { InvoiceRow } from '../types';

export function buildProvisionalDialogTitle(
  side: 'buy' | 'sell',
  existing: InvoiceRow | null,
): string {
  const verb = existing !== null ? 'Edit' : 'Create';
  const suffix = side === 'buy' ? 'Purchase Side' : 'Sales Side';
  return `${verb} Provisional Invoice — ${suffix}`;
}

export function buildProvisionalDialogDescription(existing: InvoiceRow | null): string {
  return existing !== null
    ? 'Edit any field while the invoice is in Draft. Issuing locks the invoice.'
    : 'Fill in the provisional invoice details. Saving creates a Draft on this BL.';
}
